<template>
  <div>
    <div
      v-if="isShowSideBarContent"
      class="sidebar-bk"
      @click="hideSideBarContent"
    >
    </div>
    <div
      class="section-sidebar-content bg-4a4a4a py-21 border-radius-8 mt-xl-20"
      :class="{ open: isShowSideBarContent }"
    >
      <div class="growth-score-news-wrapper">
        <div class="growth-score-news not-title">
          <div class="growth-score-news__list">
            <!-- home_url設定がある場合のホームリンク -->
            <div
              v-if="hasHomeUrl"
              class="all-post__private-wrapper bottom-border"
            >
              <div
                :class="{
                  active: isHomePage
                }"
                class="item all-post"
                @click="goToCustomHomePage"
              >
                <div class="row f-400 cl-ffffff">
                  <div class="col-1 pb-3">
                    <svg
                      width="16"
                      height="18"
                      viewBox="0 0 16 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.2 6.1626L8.45 0.918558C8.15 0.693814 7.775 0.693814 7.55 0.918558L0.8 6.1626C0.575 6.31243 0.5 6.53717 0.5 6.76192V15.0026C0.5 16.2761 1.475 17.25 2.75 17.25H13.25C14.525 17.25 15.5 16.2761 15.5 15.0026V6.76192C15.5 6.53717 15.425 6.31243 15.2 6.1626ZM9.5 9.75851V15.7517H6.5V9.75851H9.5ZM13.25 15.7517C13.7 15.7517 14 15.452 14 15.0026V7.13649L8 2.49177L2 7.13649V15.0026C2 15.452 2.3 15.7517 2.75 15.7517H5V9.00936C5 8.55988 5.3 8.26022 5.75 8.26022H10.25C10.7 8.26022 11 8.55988 11 9.00936V15.7517H13.25Z"
                        fill="#ffffff"
                      ></path>
                    </svg>
                  </div>
                  <div class="col-8 pl-10"> ホーム </div>
                </div>
              </div>
            </div>

            <div class="all-post__private-wrapper bottom-border">
              <div
                :class="{
                  active: isInCompanyPage || isInCompanyPrivacyQuestion
                }"
                class="item all-post"
                @click="goToInCompanyPage"
              >
                <div class="row f-400 cl-ffffff">
                  <div class="col-1 pb-3">
                    <img src="/images/white-icon.svg" />
                  </div>
                  <div class="col-8 pl-10">
                    社内フィード
                    <span
                      class="post-count d-inline-block fs-10 bg-333333 cl-ffffff"
                    >
                      {{ inCompanyQuestionsCount }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 学習履歴リンク -->
            <div class="all-post__private-wrapper bottom-border">
              <div
                :class="{
                  active: isWatchHistoryPage
                }"
                class="item all-post"
                @click="goToWatchHistory"
              >
                <div class="row f-400 cl-ffffff">
                  <div class="col-1 pb-3">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4 3C3.44772 3 3 3.44772 3 4V16C3 16.5523 3.44772 17 4 17H16C16.5523 17 17 16.5523 17 16V4C17 3.44772 16.5523 3 16 3H4ZM5 5H15V15H5V5ZM7 7V9H13V7H7ZM7 11V13H11V11H7Z"
                        fill="#ffffff"
                      />
                    </svg>
                  </div>
                  <div class="col-8 pl-10"> 学習履歴 </div>
                </div>
              </div>
            </div>

            <!-- 学習ダッシュボード（本番確認中は全員非表示。導線の公開時にコメントアウトを解除する）
            <div
              v-if="isShowDashboardLink"
              class="all-post__private-wrapper bottom-border"
            >
              <div
                :class="{
                  active: isDashboardPage
                }"
                class="item all-post"
                @click="goToDashboard"
              >
                <div class="row f-400 cl-ffffff">
                  <div class="col-1 pb-3">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3 17V9h3v8H3zm5.5 0V3h3v14h-3zM14 17V12h3v5h-3z"
                        fill="#ffffff"
                      />
                    </svg>
                  </div>
                  <div class="col-10 pl-10"> 学習ダッシュボード </div>
                </div>
              </div>
            </div>
            -->

            <!-- 戦略を練るリンク（一旦非表示：AIチャット導線をサイドバーから除去）
            <div
              v-if="currentUser.is_allow_ai_chat !== false"
              class="all-post__private-wrapper bottom-border"
            >
              <div
                :class="{
                  active: isAiChatPage
                }"
                class="item all-post"
                @click="goToAiChat"
              >
                <div class="row f-400 cl-ffffff">
                  <div class="col-1 pb-3">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
                        fill="#ffffff"
                      />
                    </svg>
                  </div>
                  <div class="col-10 pl-10">
                    戦略を練る
                    <span class="new-badge">NEW</span>
                  </div>
                </div>
              </div>
            </div>
            -->

            <!-- クリップリンク -->
            <!-- 本番テスト中のため一時的に非表示（URL直叩きでアクセス可能: /clips） -->
            <!-- 
            <div class="all-post__private-wrapper bottom-border">
              <div
                :class="{
                  active: isClipsPage
                }"
                class="item all-post"
                @click="goToClipsPage"
              >
                <div class="row f-400 cl-ffffff">
                  <div class="col-1 pb-3">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.5 2C2.22386 2 2 2.22386 2 2.5V13.5C2 13.7761 2.22386 14 2.5 14H9.5C9.77614 14 10 13.7761 10 13.5V8.5C10 8.22386 10.2239 8 10.5 8H13.5C13.7761 8 14 7.77614 14 7.5V2.5C14 2.22386 13.7761 2 13.5 2H2.5Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div class="col-8 pl-10">
                    クリップ
                  </div>
                </div>
              </div>
            </div>
            -->
            <div v-if="isAdvanceContact">
              <div v-if="hasThemeCourses" class="mx-12">
                <div
                  v-for="(course, i) in themeCourses"
                  :key="'course_' + i"
                  class="mb-10 bottom-border"
                >
                  <div class="growth-score-news__list-category pt-5 mb-10">
                    {{ course.name }}
                  </div>
                  <div
                    v-for="(spPage, l) in course.theme_pages"
                    :key="'theme_' + l"
                  >
                    <div
                      v-if="l < 8 || isMenuExpanded[course.name]"
                      class="lh-1 f-400 cl-ffffff mb-8 fs-14 focus-skill-name"
                      :class="{
                        sppageactive: spPage.str_id === currentSpPage.str_id
                      }"
                      @click="goToSpPage(spPage.str_id)"
                    >
                      <div class="row">
                        <div class="col-1 text-center">
                          <span v-if="spPage.has_period">
                            <span v-if="spPage.is_in_period">
                              <img src="/images/red-arrow.svg" />
                            </span>
                            <span
                              v-else
                              class="ml-6 d-inline-block text-center"
                            >
                              -
                            </span>
                          </span>
                          <span v-else>
                            <img src="/images/white-arrow.svg" />
                          </span>
                        </div>
                        <div class="col-10 pl-10">
                          {{ spPage.label }}
                          <span
                            class="page-count d-inline-block fs-10 bg-333333 cl-ffffff mx-7 px-6"
                          >
                            {{ spPage.page_count }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="lh-1 f-400 cl-ffffff mb-8 fs-12 pointer"
                    @click="toggleExpandMenu(course.name)"
                  >
                    <div v-if="course.theme_pages.length > 8">
                      <div v-if="!isMenuExpanded[course.name]"> もっと見る</div>
                      <div v-else> 閉じる</div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="hasSkillGroups" class="mx-12">
                <div
                  v-for="skillGroup in skillGroups"
                  :key="skillGroup.name"
                  class="bottom-border"
                >
                  <div class="growth-score-news__list-category pt-5 mb-10">
                    {{ skillGroup.name }}
                  </div>
                  <div
                    v-for="(spPage, l) in skillGroup.skill_pages"
                    :key="'skill30_' + l"
                  >
                    <!-- スキルメニューはデフォルトで展開される -->
                    <div
                      v-if="l < 8 || !isMenuExpanded[skillGroup.name]"
                      class="lh-1 f-400 cl-ffffff mb-8 fs-14 focus-skill-name"
                      :class="{
                        sppageactive: spPage.str_id === currentSpPage.str_id
                      }"
                      @click="goToSpPage(spPage.str_id)"
                    >
                      <div class="row">
                        <div v-if="spPage.has_focus" class="col-1 ml-6">
                          <img src="/images/focus-fire.png" />
                        </div>
                        <div v-else class="col-1 ml-6"> -</div>
                        <div class="col-10 pl-10">
                          {{ spPage.label }}
                          <span
                            class="page-count d-inline-block fs-10 bg-333333 cl-ffffff mx-7 px-6"
                          >
                            {{ spPage.page_count }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="lh-1 f-400 cl-ffffff mb-8 fs-12 text-center pointer"
                    @click="toggleExpandMenu(skillGroup.name)"
                  >
                    <!-- スキルメニューはデフォルトで展開される -->
                    <div v-if="skillGroup.skill_pages.length > 8">
                      <div v-if="isMenuExpanded[skillGroup.name]">
                        もっと見る
                      </div>
                      <div v-else> 閉じる</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="isFreeContact"
              class="item all-post all-post__public d-flex mt-6"
              :class="{
                active:
                  !isInCompanyPage &&
                  !isInCompanyPrivacyQuestion &&
                  !currentSpPage.str_id
              }"
              @click="goToHomePage"
            >
              <div class="growth-score-news__public-text f-400 cl-ffffff">
                公開投稿
              </div>
              <span class="post-count d-inline-block fs-10 bg-333333 cl-ffffff">
                {{ skillCategoryList.all_question_count }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-facing-decorator'
import { Action, namespace, State } from 'vuex-facing-decorator'
import QuestionModel from '@/model/question'
import SkillModel from '@/model/skill'
import type { SkillCategoryList } from '@/model/skill/schema'
import { privacyValue } from '@/model/schema'
import { Question } from '@/model/question/schema'
import { User, UserContractType } from '@/model/user/schema'
const AuthStore = namespace('auth')

const SkillStore = namespace('skills')

@Component({})
export default class SkillGrowthSideBar extends Vue {
  @SkillStore.Action fetchSkillCategories
  @Action toggleSideBarContent
  @State isShowSideBarContent
  @State currentSkill
  @State currentSpPage
  @State isRefreshQuestionCount
  @Action setCurrentSkill
  @Action setCurrentSpPage
  @Action setRefreshQuestionCount
  @AuthStore.Getter currentUser: User

  inCompanyQuestionsCount = 0
  PageExpandedMap = {}

  get isAdvanceContact(): boolean {
    return this.currentUser.user_contract_type === UserContractType.advance
  }

  get isFreeContact(): boolean {
    return this.currentUser.user_contract_type === UserContractType.free
  }

  get hasHomeUrl(): boolean {
    return !!this.currentUser.home_url
  }

  get isHomePage(): boolean {
    // home_urlが設定されている場合、現在のパスがhome_urlと一致するかチェック
    if (this.currentUser.home_url) {
      return this.$route.path === this.currentUser.home_url
    }
    return false
  }

  get hasSkillGroups(): boolean {
    return this.skillCategoryList.skill_groups.length > 0
  }

  get hasThemeCourses(): boolean {
    return this.skillCategoryList.courses.length > 0
  }

  get isMenuExpanded() {
    return this.PageExpandedMap
  }

  toggleExpandMenu(name: string): void {
    this.PageExpandedMap[name] = !this.PageExpandedMap[name]
  }

  get skillGroups() {
    return this.skillCategoryList.skill_groups
  }

  get themeCourses() {
    return this.skillCategoryList.courses.map((course) => ({
      ...course,
      theme_pages: this.sortThemePages(course.theme_pages)
    }))
  }

  sortThemePages(themePages) {
    return [...themePages].sort((a, b) => {
      // 項目の分類
      const getItemType = (item) => {
        if (item.is_in_period) return 1 // 期間内項目
        if (!item.has_period) return 2 // 期間なし項目
        if (item.has_period && !item.is_in_period) return 3 // 期間終了項目
        return 4 // その他
      }

      const aType = getItemType(a)
      const bType = getItemType(b)

      // タイプが異なる場合は、タイプ順でソート
      if (aType !== bType) {
        return aType - bType
      }

      // 同じタイプ内では、期間内項目と期間終了項目のみstart_atでソート
      if (aType === 1 || aType === 3) {
        // 期間内項目 または 期間終了項目
        if (!a.start_at && !b.start_at) return 0
        if (!a.start_at) return 1
        if (!b.start_at) return -1

        const dateA = new Date(a.start_at)
        const dateB = new Date(b.start_at)
        return dateA.getTime() - dateB.getTime() // 昇順
      }

      return 0
    })
  }

  get skillId() {
    return this.$route.params.skillId && Number(this.$route.params.skillId)
  }

  get spPageId() {
    return this.$route.params.spPageId
  }

  get isInCompanyPage(): boolean {
    return this.$route.name === 'InCompany'
  }

  get isClipsPage(): boolean {
    return this.$route.name === 'Clips'
  }

  get isQuestionDetailPage(): boolean {
    return this.$route.name === 'QuestionDetail'
  }

  get question(): Question | undefined {
    if (!this.isQuestionDetailPage) return undefined
    return QuestionModel.getQuestionByParams({
      id: this.$route.params.id
    })
  }

  get isInCompanyPrivacyQuestion() {
    return this.question?.privacy === privacyValue('company')
  }

  get isWatchHistoryPage(): boolean {
    return this.$route.name === 'WatchHistory'
  }

  /**
   * サイドバーに学習ダッシュボードの導線を出すか。
   * @grtx.jp のアカウントで、閲覧権限（users.is_allow_dashboard か
   * SYSTEM_ADMIN）がある場合に true。本番を含めサーバー側で判定する。
   */
  get isShowDashboardLink(): boolean {
    return this.currentUser?.is_show_dashboard_link === true
  }

  get isDashboardPage(): boolean {
    return this.$route.name === 'Dashboard'
  }

  get isAiChatPage(): boolean {
    return this.$route.name === 'AiChatList' || this.$route.name === 'AiChat'
  }

  @Watch('spPageId')
  onSpPageIdChanged(spPageId) {
    if (this.$route.name !== 'SpPage') {
      return
    }
    let self = this
    self.setCurrentSkill({})
    self.setCurrentSpPage({})

    this.skillCategoryList.skill_groups.forEach(function (group) {
      group.skill_pages.forEach(function (spPage) {
        if (spPage.str_id == spPageId) {
          self.setCurrentSpPage(spPage)
        }
      })
    })

    this.themeCourses.forEach(function (course) {
      course.theme_pages.forEach(function (spPage) {
        if (spPage.str_id == spPageId) {
          self.setCurrentSpPage(spPage)
        }
      })
    })
  }

  @Watch('isRefreshQuestionCount')
  watchRefreshQuestionCount() {
    if (this.isRefreshQuestionCount) {
      this.getSkillCategories()
      this.getInCompanyQuestionsCount()
    }
  }

  created() {
    Promise.all([this.getSkillCategories(), this.getInCompanyQuestionsCount()])
  }

  get skillCategoryList(): SkillCategoryList {
    const data = SkillModel.getSkillCategories()

    if (!data) {
      return {
        all_question_count: 0,
        skill_groups: [],
        courses: []
      } as SkillCategoryList
    }

    return data
  }

  async getInCompanyQuestionsCount() {
    const self = this
    const count = await QuestionModel.fetchAllQuestionsCount({
      params: {
        privacy: privacyValue('company')
      },
      options: {
        ignoreCache: true
      }
    })
    self.inCompanyQuestionsCount = count
    this.setRefreshQuestionCount(false)
  }

  async getSkillCategories() {
    const self = this

    await SkillModel.fetchSkillCategories({
      options: {
        ignoreCache: true
      }
    })

    // self.growScoreNews[0].listSkills = skills
    // self.growScoreNews[1].listSkills = skills

    // self.onSkillIdChanged(self.skillId)
    self.onSpPageIdChanged(self.spPageId)

    // self.growScoreNews[0].listSkills = skills
    // self.growScoreNews[1].listSkills = skills
    // self.onSkillIdChanged(self.skillId)
    self.onSpPageIdChanged(self.spPageId)

    this.setRefreshQuestionCount(false)
  }

  // goToSkillQuestions(skillId) {
  //   this.setCurrentSpPage({})
  //   if (this.skillId === Number(skillId)) return
  //   this.$router.push({name: 'SkillQuestion', params: {skillId: skillId}})
  // }

  goToHomePage() {
    this.setCurrentSkill({})
    this.setCurrentSpPage({})
    if (this.$route.name === 'Home') return
    this.$router.push({ name: 'Home' })
  }

  goToCustomHomePage() {
    this.setCurrentSkill({})
    this.setCurrentSpPage({})

    if (this.currentUser.home_url) {
      // 外部URLかチェック
      if (this.isExternalUrl(this.currentUser.home_url)) {
        window.location.href = this.currentUser.home_url
        return
      }

      // 現在のパスと同じ場合は何もしない
      if (this.$route.path === this.currentUser.home_url) {
        return
      }

      // 内部URLの場合はルーター遷移
      this.$router.push(this.currentUser.home_url)
    }
  }

  isExternalUrl(url: string): boolean {
    return url.startsWith('http://') || url.startsWith('https://')
  }

  goToInCompanyPage() {
    this.setCurrentSkill({})
    this.setCurrentSpPage({})
    if (this.isInCompanyPage) return
    this.$router.push({ name: 'InCompany' })
  }

  goToClipsPage() {
    this.setCurrentSkill({})
    this.setCurrentSpPage({})
    if (this.isClipsPage) return
    this.$router.push({ name: 'Clips' })
  }

  goToWatchHistory() {
    this.setCurrentSkill({})
    this.setCurrentSpPage({})
    if (this.isWatchHistoryPage) return
    this.$router.push({ name: 'WatchHistory' })
  }

  /**
   * 学習ダッシュボードは別タブで開く。
   * レポートを見ながら学習ページを行き来できるようにするため、いま開いている画面は閉じない。
   */
  goToDashboard() {
    const { href } = this.$router.resolve({ name: 'Dashboard' })
    // noopener を指定すると sessionStorage のログイン状態を引き継げない。
    // 同一オリジンの空タブで引き継いでから、元タブとの参照を切って移動する。
    const reportWindow = window.open('about:blank', '_blank')
    if (!reportWindow) return
    reportWindow.opener = null
    reportWindow.location.replace(href)
  }

  goToAiChat() {
    this.setCurrentSkill({})
    this.setCurrentSpPage({})
    if (this.isAiChatPage) return
    this.$router.push({ name: 'AiChatList' })
  }

  goToSpPage(spPageStrId) {
    this.setCurrentSkill({})
    if (this.spPageId === spPageStrId) return

    if (!spPageStrId) {
      spPageStrId = 'ready'
    }
    this.$router.push({ name: 'SpPage', params: { spPageId: spPageStrId } })
  }

  hideSideBarContent() {
    this.toggleSideBarContent(false)
  }
}
</script>
<style lang="scss" scoped>
.sppageactive {
  color: #13abe3 !important;
}

.bottom-border {
  margin-bottom: 8px;
  border-bottom: 1px solid #666666;
}

.focus-skill-name {
  cursor: pointer;
  @media (max-width: 767px) {
    font-size: 16px !important;
  }
}

.pointer {
  cursor: pointer;
}

.focus-skill-name:hover {
  background: #6b6b7b;
  transition: 200ms ease-in-out;
}

.page-count {
  border-radius: 10px;
  height: 16px;
  line-height: 16px;
  min-width: 21px;
  margin: auto 6px;
  padding: 0 5px;
  text-align: center;
  z-index: 1;
}

.new-badge {
  display: inline-block;
  background: rgba(255, 255, 255, 0.12);
  color: #f2f2f2;
  font-size: 9px;
  font-weight: 500;
  padding: 1px 5px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 3px;
  margin-left: 6px;
}
</style>
